import { Reducer } from "redux";
import { Action, ActionType } from "../../actions";
import { TableData } from "../../state/BookingCreateManagerV2/TableData";

const updateTableData: Reducer<TableData> = (state: TableData = new TableData(), action: Action<ActionType, TableData>) => {
  switch (action.type) {
    case ActionType.BOOKING_CREATE_MANAGER_V2_TABLE_DATA_FETCHED:
      return { ...state, records: action.data.items, totalItems: action.data.totalItems };
    default:
      return state;
  }
};

export default updateTableData;
